// extracted by mini-css-extract-plugin
module.exports = {"loaderContent":"styles_loaderContent__dNBpt","cubeContainer":"styles_cubeContainer__Fa529","cube":"styles_cube___2tN7"};